import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import { createI18n } from 'vue-i18n'

const i18n = createI18n({
  locale: 'vi',
  fallbackLocale: 'en',
  messages: {
    vi: {
      header: {
        home: 'Trang chủ',
        services: 'Dịch vụ',
        products: 'Sản phẩm',
        about: 'Về chúng tôi',
        blog: 'Blog',
        contact_us: 'Liên hệ'
      },
      footer: {
        name: 'Công ty Cổ phần công nghệ số CyberZ',
        contact: 'Liên hệ',
        phone: 'Điện thoại',
        phone_desc: '+84 902 107 790',
        address: 'Địa chỉ',
        address_desc: 'Số 8 hẻm 40/2/5 Tạ Quang Bửu, Phường Bách Khoa, Quận Hai Bà Trưng, Thành phố Hà Nội'
      },
      home: {
        html_do_our_best_to: `<span style="animation: animate 1.5s linear infinite;">&#x1f525;An toàn&#x1f525;</span> không khó`,
        html_secure_critical: `Đã có <span
        style="animation: animate 1.5s linear infinite;">CyberZ</span> lo <span style="color: #ffcb00"><i class="fas fa-bolt"></i></span>`,
        we_bring_the_best: `CyberZ cung cấp dịch vụ, công cụ an toàn thông tin cho cá nhân và tổ chức, doanh nghiệp trước thời đại công nghệ số.`,
        discover_more: `Tìm hiểu thêm`,
        why_choose_us: `Chúng tôi có gì?`,
        why_choose_us_desc: `Những điều làm nên thương hiệu của CyberZ`,
        cybersec_expertise: `Chuyên môn về ATTT`,
        cybersec_expertise_desc: `Đội ngũ chúng tôi bao gồm các chuyên gia hàng đầu trong lĩnh vực an toàn thông tin đã và đã có nhiều thành tích trong nước cũng như quốc tế`,
        experience: `Kinh nghiệm`,
        experience_desc: `CyberZ có nhiều năm kinh nghiệm trong việc xây dựng và triển khai công cụ đảm bảo an toàn cho các công ty, tổ chức`,
        trust: `Sự tin tưởng`,
        trust_desc: `Nhiều cá nhân, tổ chức đã tin tưởng, lựa chọn, sử dụng dịch vụ và công cụ của CyberZ cho các hệ thống trọng yếu của họ`,
        core_value_1: `Giá trị`,
        core_value_2: `cốt lõi`,
        core_value_3: `của CyberZ`,
        core_value_desc: `CyberZ luôn lắng nghe, quan tâm và cùng phối hợp với khách hàng để đưa ra những sản phẩm, dịch vụ phù hợp với yêu cầu, mong muốn của khách hàng nhất.`,
        core_value_desc_2: `Bạn sẽ luôn tìm được câu trả lời tốt nhất cho trường hợp của mình khi làm việc với CyberZ.`,
        core_value_btn: `Liên hệ ngay`,
        services: `Dịch vụ`,
        services_desc: `Dưới đây là các dịch vụ phổ biến của chúng tôi`,
        services_1: `Xây dựng chiến lược đảm bảo ATTT`,
        services_1_desc: `Đánh giá mức độ trưởng thành an toàn thông tin; Tư
        vấn xây dựng chương trình chiến lược đảm bảo ATTT`,
        services_2: `Chủ động xác định các rủi ro gây
        mất ATTT`,
        services_2_desc: `Đánh giá lỗ hổng bảo mật, Kiểm thử xâm nhập Web và
        ứng dụng di động, Kiểm thử xâm nhập hạ tầng hệ thống CNTT, Đánh giá mã nguồn sản phẩm, Đánh
        giá cấu hình bảo mật hệ thống, thiết bị.`,
        services_3: `Ngăn chặn kịp thời ảnh hưởng của
        cuộc xâm nhập`,
        services_3_desc: `Truy tìm các mối đe dọa an ninh mạng (threat
          hunting); Quản lý sự cố an toàn thông tin`,
        services_4: `Giải pháp, công nghệ bảo mật với
        chi phí cạnh tranh`,
        services_4_desc: `Giải pháp quản lý lỗ hổng bảo mật; phát hiện và ngăn
        chặn xâm nhập; theo dõi, phát hiện và cảnh báo sớm các nguy cơ an ninh mạng`,
        services_5: `Cải thiện mắt xích yếu nhất trong
        ATTT`,
        services_5_desc: `Đào tạo nhận thức ATTT cho người dùng cuối; Đào tạo
        kiến thức cho đội ngũ kỹ thuật; Diễn tập an ninh mạng`,
        services_6: `Xây dựng giải pháp kỹ thuật`,
        services_6_desc: `Xây dựng công cụ, giải pháp kỹ thuật hỗ trợ, phục vụ
        ATTT; Gia công phần mềm ATTT; Nghiên cứu giải pháp, kỹ thuật đảm bảo ATTT`,
        products: `Sản phẩm`,
        products_desc: `Sản phẩm của chúng tôi mang lại sự tiện lợi trong việc đảm
        bảo an toàn thông tin với chỉ 1 cú click chuột`,
        products_1: `Công cụ dò quét lỗ hổng bảo mật`,
        products_1_price: `Miễn phí`,
        products_1_btn: `Sắp ra mắt`,
        products_1_f_1: `Miễn phí sử dụng công cụ`,
        products_1_f_2: `Hỗ trợ
        24/7`,
        products_1_f_3: `Hỗ trợ khắc
        phục lỗ hổng`,
        products_1_f_4: `Tư vấn đảm
        bảo ATTT`,
        blog: `Blog và bài viết kỹ thuật`,
        blog_desc: `Chia sẻ kỹ thuật, kinh nghiệm từ các chuyên gia của CyberZ`,
      }
    },
    en: {
      header: {
        home: 'Home',
        services: 'Services',
        products: 'Products',
        about: 'About',
        blog: 'Blog',
        contact_us: 'Contact Us'
      },
      footer: {
        name: 'CyberZ digital technology joint stock company',
        contact: 'Contact',
        phone: 'Phone',
        phone_desc: '+84 902 107 790',
        address: 'Address',
        address_desc: 'No. 8, alley 40/2/5 Ta Quang Buu, Bach Khoa Ward, Hai Ba Trung District, Hanoi City'
      },
      home: {
        html_do_our_best_to: `Do our <span style="animation: animate 1.5s linear infinite;">&#x1f525;best&#x1f525;</span> to`,
        html_secure_critical: `Secure your <span
        style="animation: animate 1.5s linear infinite;">Critical</span>
      Infrastructure <span style="color: #ffcb00"><i class="fas fa-bolt"></i></span>`,
        we_bring_the_best: `We bring the best products and services to help you protect your important things.`,
        discover_more: `Discover More`,
        why_choose_us: `Why Choose Us`,
        why_choose_us_desc: `What make CyberZ brand name`,
        cybersec_expertise: `Cyber Security Expertise`,
        cybersec_expertise_desc: `Our team consists of leading experts in the field of information security who have had many domestic and international achievements.`,
        experience: `Experience`,
        experience_desc: `CyberZ has many years of experience in building and deploying security tools for companies and organizations`,
        trust: `Trust`,
        trust_desc: `Many individuals and organizations have trusted, selected, and used CyberZ's services and tools for their critical systems.`,
        core_value_1: `CyberZ`,
        core_value_2: `Core`,
        core_value_3: `value`,
        core_value_desc: `CyberZ always listens, cares and cooperates with customers to offer products and services that best suit the requirements and wishes of customers..`,
        core_value_desc_2: `You will always find the best answer for your case when working with CyberZ.`,
        core_value_btn: `Contact now`,
        services: `Services`,
        services_desc: `Here are our popular services`,
        services_1: `Develop a strategy to ensure security`,
        services_1_desc: `Assessment of information security maturity level; Consulting on building strategic programs to ensure information security`,
        services_2: `Proactively identify risks causing loss of information security`,
        services_2_desc: `Vulnerability assessment, Web and mobile application penetration testing, IT infrastructure penetration testing, Product source code assessment, System and device security configuration assessment.`,
        services_3: `Timely containment of the impact of the intrusion`,
        services_3_desc: `Tracing network security threats (threat hunting); Information security incident management`,
        services_4: `Security solutions and technology at competitive costs`,
        services_4_desc: `Vulnerability management solutions; intrusion detection and prevention; monitoring, detecting and early warning of network security risks`,
        services_5: `Improve the weakest link in ATTT`,
        services_5_desc: `Training awareness of information security for end users; Knowledge training for technical staff; Cybersecurity drills`,
        services_6: `Building technical solutions`,
        services_6_desc: `Building tools and technical solutions to support and serve information security; Outsourcing ATTT; Researching solutions and techniques to ensure information security`,
        products: `Products`,
        products_desc: `Our products bring convenience in ensuring information security with just 1 click`,
        products_1: `Vulnerability Scanning Tool`,
        products_1_price: `Free`,
        products_1_btn: `Coming soon`,
        products_1_f_1: `Free to use tool`,
        products_1_f_2: `24/7 support`,
        products_1_f_3: `Support to fix security holes`,
        products_1_f_4: `Consulting to ensure safety`,
        blog: `Blogs and technical articles`,
        blog_desc: `Sharing techniques and experiences from CyberZ experts`,
      }
    }
  },
})

createApp(App).use(i18n).use(store).use(router).mount('#app')
